import React from 'react';
import Modal, { useModal } from '../../Components/Modal';
import TextArea from '../../Components/Inputs/TextArea';
import { useSuggestion } from '../../Data/Help';

const Suggestion = ({isOpen, setIsOpen}) => {

    return <Modal title="Feedback & Suggestions" isOpen={isOpen} setIsOpen={setIsOpen} dismissible>

        <p className="py-4 text-muted text-sm text-balance">
            We always love hearing your feedback and suggestions.<br />
            We read it all, and it help us keep improving!
        </p>

        <Inner />
    </Modal>
}

const Inner = () => {
    const {closeModal} = useModal();
    const {submit} = useSuggestion();

    const handleSubmit = (val) => {
        return submit(val).then(closeModal);
    }

    return <TextArea prompt="I'd love it if..." onSubmit={handleSubmit} submitLabel="Submit" />
}

export default Suggestion;
